import classNames from "classnames";
import Link from "next/link";

export const FAQLink = ({ href, children, className = "" }) => {
  return (
    <Link
      href={href}
      target="_blank"
      className={classNames(
        "inline-block hover:opacity-50 a-hover-line2 border-solid border-0 border-b border-white leading-[17px]",
        className
      )}
    >
      {children}
    </Link>
  );
};
